import React from 'react'

import cx from 'classnames'

import { Div } from '@driftt/tide-core'

import ChartBody, { IChartBodyProps } from '../ChartBody'
import ChartHeader, { IChartHeaderProps } from '../ChartHeader'

import './style.css'

export interface IChartContainerProps<T>
  extends IChartHeaderProps,
    IChartBodyProps<T> {
  className?: string
}

export const BasicChartContainer = <T extends object>({
  className,
  cumulative,
  title,
  subtitle,
  inlineCountChart,
  tooltip,
  tooltipFlow,
  renderPrimaryContent,
  renderAdditionalContent,
  renderBottomContent,
  children,
}: React.PropsWithChildren<IChartContainerProps<T>>) => (
  <Div className={cx('chart-container', className)}>
    <ChartHeader
      title={title}
      subtitle={subtitle}
      tooltip={tooltip}
      tooltipFlow={tooltipFlow}
      inlineCountChart={inlineCountChart}
      cumulative={cumulative}
      renderPrimaryContent={renderPrimaryContent}
      renderAdditionalContent={renderAdditionalContent}
      renderBottomContent={renderBottomContent}
    />
    <Div className="chart-container-body">{children}</Div>
  </Div>
)

const ChartContainer = <T extends object>({
  className,
  cumulative,
  title,
  subtitle,
  inlineCountChart,
  tooltip,
  tooltipFlow,
  renderPrimaryContent,
  renderAdditionalContent,
  renderBottomContent,
  ...bodyProps
}: IChartContainerProps<T>) => (
  <BasicChartContainer
    className={className}
    title={title}
    subtitle={subtitle}
    tooltip={tooltip}
    tooltipFlow={tooltipFlow}
    inlineCountChart={inlineCountChart}
    cumulative={cumulative}
    renderPrimaryContent={renderPrimaryContent}
    renderAdditionalContent={renderAdditionalContent}
    renderBottomContent={renderBottomContent}
  >
    <ChartBody<T> {...bodyProps} />
  </BasicChartContainer>
)

export default ChartContainer
